<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <Aviso
          mensagem="Cálculo de acordo com a Portaria TCDF 212/2002 c/c Emenda Regimental 1/2019."
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <FormCalculo tipo="debitosApuracao">
          <template v-slot:jurosDatePicker="{ habilitarDataJuros }">
            <DatePicker
              :habilitarDataJuros="habilitarDataJuros"
              ref="dataJurosDatePicker"
              nome="Data de início da incidência dos juros"
              regras="data"
              tipo="dataJuros"
              dica="Juros e/ou multa incidentes em casos de má-fé"
            />
          </template>
        </FormCalculo>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <Resultados nome="Débitos em Apuração" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormCalculo from "@/components/FormCalculo.vue";
import Resultados from "@/components/Resultados.vue";
import Aviso from "@/components/Aviso.vue";
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    FormCalculo,
    Resultados,
    Aviso,
    DatePicker
  }
};
</script>

<style lang="scss" scoped></style>
